(function autoCloseDetails() {
    document.addEventListener('click', function (event) {
        // Accordions
        const accordions = document.querySelectorAll(".auto-close.accordion")

        accordions.forEach(accordion => {
            if (!(event.target instanceof Node) || !accordion.contains(event.target)) return

            accordion.querySelectorAll("details")
                .forEach(row => {
                    if (!(event.target instanceof Node && row.contains(event.target))) row.removeAttribute("open")
                })
        })

        // Small dropdowns

        const dropdowns = document.querySelectorAll("accordion-custom.facets__item")

        dropdowns.forEach(dropdown => {
            dropdown.querySelectorAll("details")
                .forEach(menu => {
                    if (!(event.target instanceof Node && menu.contains(event.target))) menu.removeAttribute("open")
                })
        })
    });
})();
